import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { AppPushApiPort } from 'application/common/port/app-push-api.port';
import { MessageApiPort } from 'application/message/port/message-api.port';
import { NotificationApiPort } from 'application/notification/port/notification-api.port';
import { ContactApiPort } from 'contact/port/contact-api.port';
import { DocumentApiPort } from 'document/port/document-api.port';
import { AppPushApiAdapter } from 'infrastructure/adapter/common/app-push-api.adapter';
import { ContactApiAdapter } from 'infrastructure/adapter/contact/contact-api.adapter';
import { DocumentApiAdapter } from 'infrastructure/adapter/document/document-api.adapter';
import { JobOfferApiAdapter } from 'infrastructure/adapter/job/job-offer-api-adapter.service';
import { MessageApiAdapter } from 'infrastructure/adapter/message/message-api.adapter';
import { ModuleApiAdapter } from 'infrastructure/adapter/module/module-api.adapter';
import { NotificationApiAdapter } from 'infrastructure/adapter/notification/notification-api.adapter';
import { PhaseApiAdapter } from 'infrastructure/adapter/phase/phase-api.adapter';
import { TaskApiAdapter } from 'infrastructure/adapter/task/task-api.adapter';
import { UserAnalyticsAdapter } from 'infrastructure/adapter/user/user-analytics.adapter';
import { UserApiAdapter } from 'infrastructure/adapter/user/user-api.adapter';
import { UserContactCompanyApiAdapter } from 'infrastructure/adapter/user/user-contact-company-api-adapter.service';
import { UserSessionAdapter } from 'infrastructure/adapter/user/user-session.adapter';
import { ApiGraphqlModule } from 'infrastructure/common/api-graphql.module';
import { JobOfferApiPort } from 'job/port/job-offer-api.port';
import { ModuleApiPort } from 'module/port/module-api.port';
import { PhaseApiPort } from 'phase/port/phase-api.port';
import { TaskApiPort } from 'task/port/task-api.port';
import { UserContactCompanyApiPort } from 'user/port/contact/user-contact-company-api.port';
import { UserAnalyticsPort } from 'user/port/user-analytics.port';
import { UserApiPort } from 'user/port/user-api.port';
import { UserSessionPort } from 'user/port/user-session.port';

@NgModule({
	imports: [ApiGraphqlModule],
	exports: [ApiGraphqlModule],
	providers: [
		{
			provide: UserContactCompanyApiPort,
			useClass: UserContactCompanyApiAdapter,
		},
		{ provide: NotificationApiPort, useClass: NotificationApiAdapter },
		{ provide: UserAnalyticsPort, useClass: UserAnalyticsAdapter },
		{ provide: DocumentApiPort, useClass: DocumentApiAdapter },
		{ provide: UserSessionPort, useClass: UserSessionAdapter },
		{ provide: JobOfferApiPort, useClass: JobOfferApiAdapter },
		{ provide: ModuleApiPort, useClass: ModuleApiAdapter },
		{ provide: MessageApiPort, useClass: MessageApiAdapter },
		{ provide: AppPushApiPort, useClass: AppPushApiAdapter },
		{ provide: ContactApiPort, useClass: ContactApiAdapter },
		{ provide: PhaseApiPort, useClass: PhaseApiAdapter },
		{ provide: TaskApiPort, useClass: TaskApiAdapter },
		{ provide: UserApiPort, useClass: UserApiAdapter },
		CookieService,
	],
})
export class AppInfrastructureModule {}
